export const STORE_USER = 'STORE_USER'
export const USER_SIGNED_OUT = 'USER_SIGNED_OUT'
export const USER_EXPIRED = 'USER_EXPIRED'
export const STORE_USER_ERROR = 'STORE_USER_ERROR'
export const LOADING_USER = 'LOADING_USER'

export const FILTER_DATA = 'FILTER_DATA'
export const NOT_DIRECT_FILTER_DATA = 'NOT_DIRECT_FILTER_DATA'
export const SELECTED_MENU = 'SELECTED_MENU'
export const DATA_TABLE_PAYLOAD = 'DATA_TABLE_PAYLOAD'
export const EDIT_TABLE_PAYLOAD = "EDIT_TABLE_PAYLOAD"
export const EMPTY_EDIT_TABLE_PAYLOAD = "EMPTY_EDIT_TABLE_PAYLOAD"
export const ADD_PAYLOAD = 'ADD_PAYLOAD'
export const EMPTY_ADD_PAYLOAD = 'EMPTY_ADD_PAYLOAD'
export const EDIT_PAYLOAD = "EDIT_PAYLOAD"
export const EDIT_PAYLOAD_FAMILYGROUP = "EDIT_PAYLOAD"
export const EMPTY_PAYLOAD_FAMILYGROUP = "EMPTY_PAYLOAD"
export const DELETE_PAYLOAD = 'DELETE_PAYLOAD'
export const FAMILY_GROUP_SEARCH_PAYLOAD = 'FAMILY_GROUP_SEARCH_PAYLOAD'
export const SEARCH_PAYLOAD = 'SEARCH_PAYLOAD'
export const FAMILY_GROUP_MENU_HEADER_PAYLOAD = 'FAMILY_GROUP_MENU_HEADER_PAYLOAD'
export const PAGE_DIRTY_PAYLOAD = 'PAGE_DIRTY_PAYLOAD'
export const SEARCH_COUNT_PAYLOAD = 'SEARCH_COUNT_PAYLOAD'
